import React from "react";
import { Icons } from "../Icons";
import "./heading.scss";
import { Col, Row } from "react-bootstrap";
export const Headings = (props) => {
  const handleHeadingClick = () => {
    if (typeof props.handleClick === "function") {
      props.handleClick();
    }
  };

  return (
    <Row>
      <Col xs={props.bigTitle ? 12 : 8}>
        <h1
          className={
            props.iconName || props.headIconName
              ? props.pageTitle
                ? `c-section-header_title js-sticky-anchor page-section-heading`
                : `c-section-header_title js-sticky-anchor`
              : props.pageTitle
                ? `big-heading c-section-header_title js-sticky-anchor ${
                    props.bigTitle
                      ? `page-section-heading big-header-title`
                      : props.popupTitle
                        ? `page-section-heading popup-title`
                        : `page-section-heading`
                  } `
                : `big-heading c-section-header_title js-sticky-anchor`
          }
        >
          {props.pageTitle ? props.pageTitle : props.title}
          {props.iconName ? (
            <div>
              <button
                type="button"
                onClick={handleHeadingClick}
                className="btn btn-tertiary c-section-header_edit custom-link"
              >
                {props.title === "Time travel" ? (
                  ""
                ) : (
                  <span className="icon">
                    <Icons
                      iconname={props.iconName}
                      variant={props.iconVariant}
                    />
                  </span>
                )}

                <span>
                  {props.title === "Time travel" ? "Tell me more" : "Edit"}
                </span>
              </button>
              <Icons
                iconname="external-link"
                variant="icon-twelve-px ms-1 mt-2"
              />
            </div>
          ) : props.seeAllGoals === "See all" ? (
            <div>
              <button
                type="button"
                onClick={handleHeadingClick}
                className="btn btn-tertiary c-section-header_edit custom-link"
              >
                <span>{props.seeAllGoals}</span>
                <Icons iconname="external-link" variant="icon-twelve-px ms-1" />
              </button>
            </div>
          ) : (
            ""
          )}
        </h1>
      </Col>
      {props.headIconName ? (
        <Col xs={4} className="d-flex justify-content-center">
          <span className="large-icon">
            <Icons
              iconname={props.headIconName}
              variant={props.headIconVariant}
              data-testid="head-icon"
            />
          </span>
        </Col>
      ) : (
        ""
      )}
    </Row>
  );
};
